import { render } from "./index.vue?vue&type=template&id=5df9647f&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5df9647f&lang=scss&scoped=true"

import exportComponent from "E:\\leilongObject\\庆亚\\qingya_v3\\qingya_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df9647f"]])

export default __exports__